import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Estate_FieldsFragment } from 'queries';

const useStyles = makeStyles(() => ({
  pill: {
    display: 'inline-block',
    background: '#F9F9F9',
    borderRadius: '4px',
    padding: '4px 8px',
    fontSize: '12px',
  },
  suggestionsLink: {
    fontSize: '12px',
    marginTop: '4px',
    color: '#1C2541',
  },
  title: {
    fontSize: '24px',
    fontWeight: 700,
    marginBottom: '48px',
  },

  badges: {
    display: 'flex',
    gap: '8px',
    marginBottom: '16px',
  },
}));

type Props = {
  estate: Estate_FieldsFragment;
  pageTitle: string;
};

const EstateBalanceSheetDashboardHeader = ({ estate, pageTitle }: Props) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.badges}>
        <div className={classes.pill}>PRIVILEGED AND CONFIDENTIAL</div>
        <div className={classes.pill}>BETA</div>
      </div>
      <Typography variant="h1" className={classes.title}>
        {estate.estateName} {pageTitle}
      </Typography>
    </>
  );
};

export default EstateBalanceSheetDashboardHeader;
